import { render, staticRenderFns } from "./MenuReportOrder.vue?vue&type=template&id=06924a8a&"
import script from "./MenuReportOrder.vue?vue&type=script&lang=js&"
export * from "./MenuReportOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports